import axiosEncodedConfig from '../../axiosEncodedConfig';

export const exchangeCodeForToken = async (code,codeVerifier) => {
    try {
        const clientId = process.env.REACT_APP_IDP_CLIENT_ID;
        const tenantId = process.env.REACT_APP_IDP_TENANT_ID;
        const baseUrl = process.env.REACT_APP_IDP_BASE_URL;
        const redirectUri = process.env.REACT_APP_IDP_REDIRECT_URI;
        const scope = process.env.REACT_APP_IDP_SCOPE;
        const response = await axiosEncodedConfig.post(`${baseUrl}/${tenantId}/oauth2/v2.0/token`, {
            'code':code,
            'code_verifier':codeVerifier,
            'grant_type': 'authorization_code',
            'client_id': clientId,
            'scope': scope,
            'redirect_uri': redirectUri,
        })

        return response.data.access_token;
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};